'use strict';

var _ = require('lodash');
function FlightManagementParallelizeQueryService(app, momentService, SearchCriteria, dataRetrieverService, dataRetrieverConstantsService) {
  var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.FLIGHT_SUMMARY);
  var PAGE_LIMIT = dataRetriever.currentPageLimit() || _.get(app, 'pageLimit', 5000);
  var MAX_THREADS = dataRetriever.threadsQuantity() || _.get(app, 'threadsQuantity', 4);
  function canParallelize(recordsSize) {
    return recordsSize > PAGE_LIMIT;
  }
  function getDateRanges(rules) {
    return _.reduce(rules, function (result, rule) {
      var leftRange, rightRange, range;
      switch (rule.operator) {
        case 'Between':
          range = rule.leftOperand.clone().value.twix(rule.rightOperand.clone().value.subtract(1, 'day'), {
            allDay: true
          });
          break;
        case 'Not Between':
          leftRange = [rule.leftOperand.clone().subtract(182, 'day'), rule.leftOperand.clone().subtract(2, 'day')];
          rightRange = [rule.rightOperand.clone(), rule.rightOperand.clone().add(183, 'day')];
          range = [leftRange[0].value.twix(leftRange[1].value, {
            allDay: true
          }), rightRange[0].value.twix(rightRange[1].value, {
            allDay: true
          })];
          break;
        case '=':
          range = rule.leftOperand.value.twix(rule.leftOperand.value, {
            allDay: true
          });
          break;
        case '!=':
          leftRange = [rule.leftOperand.clone().subtract(182, 'day'), rule.leftOperand.clone().subtract(2, 'day')];
          rightRange = [rule.leftOperand.clone(), rule.leftOperand.clone().add(183, 'day')];
          range = [leftRange[0].value.twix(leftRange[1].value, {
            allDay: true
          }), rightRange[0].value.twix(rightRange[1].value, {
            allDay: true
          })];
          break;
        case '<':
          range = rule.leftOperand.clone().subtract(1, 'year').value.twix(rule.leftOperand.subtract(2, 'day').value, {
            allDay: true
          });
          break;
        case '<=':
          range = rule.leftOperand.clone().subtract(1, 'year').value.twix(rule.leftOperand.subtract(1, 'day').value, {
            allDay: true
          });
          break;
        case '>':
          range = rule.leftOperand.clone().add(1, 'day').value.twix(rule.leftOperand.add(1, 'year').value, {
            allDay: true
          });
          break;
        case '>=':
          range = rule.leftOperand.clone().value.twix(rule.leftOperand.add(1, 'year').value, {
            allDay: true
          });
          break;
      }
      if (_.isArray(range)) {
        result = _.concat(result, range);
      } else {
        result.push(range);
      }
      return result;
    }, []);
  }
  function transformRangeToRule(range, threads) {
    var dividedRange = range.divide(threads);
    return _.transform(dividedRange, function (partials, range) {
      var leftOperand = momentService.of(range.start().clone(), momentService.FIELD.ND_DEPARTURE_DATE);
      var rightOperand = momentService.of(range.end().clone(), momentService.FIELD.ND_DEPARTURE_DATE);
      partials.push(new SearchCriteria({
        category: 'Time & Date',
        criterion: 'Departure Date',
        field: 'custom:numberDepartureDate',
        operator: 'Between',
        leftOperand: leftOperand,
        rightOperand: rightOperand
      }));
    }, []);
  }
  function getPartialRules(range, rule) {
    var rangeRules = _.isArray(range) ? subRangesToRules(range, rule) : transformRangeToRule(range, MAX_THREADS, rule);
    return _.map(rangeRules, function (rule, index) {
      if (index > 0) {
        rule.leftOperand = rule.leftOperand.add(1, 'day');
      }
      return rule;
    });
  }
  function subRangesToRules(range, rule) {
    var subrangeThreadAllocated = Math.ceil(MAX_THREADS / range.length);
    return _.reduce(range, function (rules, subRange, index) {
      var nextMaxThread = subrangeThreadAllocated * (index + 1);
      if (nextMaxThread > MAX_THREADS) {
        subrangeThreadAllocated = subrangeThreadAllocated - (nextMaxThread - MAX_THREADS);
      }
      rules = rules.concat(transformRangeToRule(subRange, subrangeThreadAllocated, rule));
      return rules;
    }, []);
  }
  function buildDataRanges(dateRules) {
    var ranges = [];
    if (!_.size(dateRules)) {
      var now = momentService.now(momentService.FIELD.DEPARTURE_DATE);
      ranges.push(now.value.twix(now.value.clone().add(1, 'year')));
    }
    ranges = _.concat(ranges, getDateRanges(dateRules));
    return getPartialRules(mergeRanges(ranges));
  }
  function mergeOverlaps(ranges, currentRange) {
    var afterMergeRange = _.transform(ranges, function (newRanges, range) {
      if (currentRange.overlaps(range)) {
        currentRange = currentRange.union(range);
      } else {
        newRanges.push(range);
      }
      return newRanges;
    }, []);
    return {
      range: currentRange,
      ranges: afterMergeRange
    };
  }
  function rangeSort(rangeA, rangeB) {
    if (rangeA.start().isBefore(rangeB.start())) {
      return -1;
    }
    if (rangeA.start().isAfter(rangeB.start())) {
      return 1;
    }
    return 0;
  }
  function mergeRanges(ranges) {
    var mergedRanges = [];
    ranges.sort(rangeSort);
    do {
      var selectedRange = ranges.shift();
      var newRangeObject = mergeOverlaps(ranges, selectedRange);
      selectedRange = newRangeObject.range;
      ranges = newRangeObject.ranges;
      mergedRanges.push(selectedRange);
    } while (_.size(ranges));
    return mergedRanges;
  }
  function splitRules(rules) {
    return {
      fixed: _.reject(rules, {
        category: 'Time & Date',
        criterion: 'Departure Date'
      }),
      departureDate: _.filter(rules, {
        category: 'Time & Date',
        criterion: 'Departure Date'
      })
    };
  }
  return {
    canParallelize: canParallelize,
    splitRules: splitRules,
    buildDataRanges: buildDataRanges
  };
}
FlightManagementParallelizeQueryService.$inject = ['App', 'MomentService', 'SearchCriteriaRuleFactory', 'DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = FlightManagementParallelizeQueryService;